/**
 * TimeAgo — wraps a relative-time label ("3m ago") so hovering it reveals the
 * exact moment as a dark tooltip pill: "Jul 21, 2026, 12:11 AM GMT+5:30".
 * Pass the source timestamp as `iso`; the visible label stays whatever the
 * call site already renders (each surface keeps its own relative formatter).
 */

import React from 'react';
import HoverPopover from './HoverPopover';

const absFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZoneName: 'shortOffset',
});

export const formatExactTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return absFormatter.format(d);
};

export default function TimeAgo({ iso, children }) {
  // Invalid/missing timestamp → HoverPopover renders the label transparently.
  return (
    <HoverPopover variant="tooltip" content={formatExactTime(iso)}>
      {children}
    </HoverPopover>
  );
}
